import { Response } from '@marketplace-web/shared/api-client'
import { transformCurrencyAmountDto } from '@marketplace-web/domain/currency-data'

import {
  CustomShipmentConfigDto,
  CustomShipmentConfigModel,
  CustomShipmentConfigResp,
} from '../types/shipment-custom-config'

export const transformCustomShipmentDto = ({
  prices,
}: CustomShipmentConfigDto): CustomShipmentConfigModel => ({
  prices: {
    minimum: transformCurrencyAmountDto(prices.minimum),
    maximum: transformCurrencyAmountDto(prices.maximum),
  },
})

export const transformGetCustomShipmentConfig = (response: Response<CustomShipmentConfigResp>) =>
  transformCustomShipmentDto(response.custom_shipment_configuration)
